import React from "react";
import NnNavBar from "./NnNavBar";
import NnPianoKeyboard from "./NnPianoKeyboard";
import NnDisplay from "./NnDisplay";
import NnSounds from "./NnSounds";
import Song from "./Song";
import SongManager from "./SongManager";

class NnPlayerPianoApp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      songId: props.songId
    };

    // workaround EC6 unbound methods
    this.loadSong = this.loadSong.bind(this);
    this.setSong = this.setSong.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.playSong = this.playSong.bind(this);
    this.handlePianoKeyPress = this.handlePianoKeyPress.bind(this);
  }

  render() {
    return (
      <div>
        <NnNavBar onPlaySong={this.playSong} />
        <NnDisplay
          song={this.state.song}
          position={this.state.position}
          cover={this.state.cover}
        />
        <NnPianoKeyboard
          song={this.state.song}
          onKeyPress={this.handlePianoKeyPress}
          nextNote={this.state.currentNote}
        />
        <NnSounds />
      </div>
    );
  }
  componentDidMount() {
    this.loadSong(this.state.songId);
  }

  // TDOO: convert to getDerivedStateFromProps
  componentWillReceiveProps(nextProps) {
    if (nextProps.songId !== this.state.songId) {
      this.loadSong(nextProps.songId);
    }
  }

  // this takes a filepath and loads a song from it, making it the currentSong
  loadSong(songId) {
    // console.log("NnPlayerPianoApp.loadSong " + songId);
    this.setState({songId: songId});
    let song = new Song();
    let url = SongManager.getSongUrlFromId(songId);
    song.readFromCsvFile(url, this.setSong);
  }

  setSong(song) {
    // console.log("NnPlayerPianoApp.setSong " + song.name);
    this.setState({
      song: song,
      position: 0,
      currentNote: song.currentNote(),
      cover: song.coverImageUrl
    });
  }

  setPosition(index) {
    this.setState({
      position: index,
      currentNote: this.state.song ? this.state.song.currentNote() : null
    });
  }

  // play straight through the song
  playSong() {
    this.state.song && this.state.song.play(this.state.position);
  }

  // if the key pressed is the next song note then advance the song
  handlePianoKeyPress(note) {
    if (note === this.state.currentNote.name) {
      this.state.song.advance();
      this.setPosition(this.state.song.currentPosition);
    }
  }
}
export default NnPlayerPianoApp;



// WEBPACK FOOTER //
// ./src/NnPlayerPianoApp.js